import { convertToCard, updateNote, deleteNote, removeNoteFromPanel } from '@/components/ContextDoc/use/useDocActions';
import { reactive, toRefs } from '@vue/composition-api';
import { pagesModule, buildBreadcrumbs } from '@/store/database/pagesModule';
import useMultiSelect from '@/views/Context/use/useMultiSelect';

const state = reactive({
  show: false, //  true or false
  selectedPageId: null,
  parentPageId: null,
  noteId: null,
  breadcrumbs: []
});

export default function useArchiveModal() {
  const openArchiveModal = ({ selectedPageId, parentPageId, noteId }) => {
    console.log('open archive modal', selectedPageId, parentPageId, noteId);
    state.selectedPageId = selectedPageId;
    state.parentPageId = parentPageId;
    state.noteId = noteId;
    // state.show = true;
    state.breadcrumbs = buildBreadcrumbs(selectedPageId);
    console.log(state.breadcrumbs);


    handleArchivePage();
  };

  const handleArchivePage = ({ pageId, parentPageId, noteId, embed = false } = {}) => {
    //  Check if multiselected
    const { getSelectedNoteIds } = useMultiSelect();
    const selectedNoteIds = getSelectedNoteIds();
    const parentPage = pagesModule.doc(parentPageId).data;
    if (selectedNoteIds.includes(noteId)) {
      const selectedNotes = selectedNoteIds.map(n => parentPage.pageNotes[n]);
      selectedNotes.forEach(n => {
        convertToCard({ pageId: n.pageId });
        removeNoteFromPanel({ pageId: parentPageId, noteId: n.id });
      });
    } else {
      convertToCard({ pageId });
      removeNoteFromPanel({ pageId: parentPageId, noteId });
    }
    // console.log('archive pages!');
    // //  pass in embed true to embed the card, otherwise we will just remove the note
    // pagesToArchive.forEach(pageId => {
    //   convertToCard({ pageId });
    //   if (embed) {
    //     // update the note.
    //     const update = { pageId: null, noteCardId: pageId };
    //     updateNote({ pageId: parentPageId, noteId, update });
    //   } else {
    //     // remove the note
    //     console.log('deleteNote');
    //     const notes = Object.values(parentPage.pageNotes);
    //     const parentNote = notes.find(n => n.pageId == pageId && !n.toDelete);
    //     console.log(parentPageId, parentPage, notes, parentNote);
    //     removeNoteFromPanel({ pageId: parentPageId, noteId: parentNote.id });
    //   }
    // })
    // closeArchiveModal();
  };

  const closeArchiveModal = () => {
    state.show = false;
    state.selectedPageId = null;
    state.parentPageId = null;
    state.noteId = null;
  };

  return {
    openArchiveModal,
    closeArchiveModal,
    handleArchivePage,
    ...toRefs(state)
  };
}
